<h2 mat-dialog-title>Create A Directory</h2>

<mat-dialog-content [formGroup]="form">
  
    <mat-form-field appearance="fill">
        <input 
            matInput
            placeholder="Directory Name"
            formControlName="directoryName">
    </mat-form-field>
 
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button setColor="primaryColour" color="primary" class="submit-button" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid" >Save</button>
</mat-dialog-actions>